export const hasConsentChecked = new Promise(resolve => {
	window.addEventListener("metaTagSystemCmpConsentAvailable", () => {
		const triggerPrivacySettings = () =>
			window._sp_.gdpr.loadPrivacyManagerModal(557081);
		// @see https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20CMP%20API%20v2.md#addeventlistener
		window.__tcfapi("addEventListener", 2, tcData => {
			if (!tcData.gdprApplies) {
				resolve({
					uiShown: false,
					allPurposesConsent: true,
					triggerPrivacySettings,
				});
				return;
			}

			const consents = Object.entries(tcData.purpose.consents);
			const allPurposesConsent =
				consents.length > 0 && consents.every(([, consent]) => consent);
			resolve({
				uiShown: tcData?.eventStatus != "tcloaded",
				allPurposesConsent,
				triggerPrivacySettings,
			});
		});
	});

	// usercentrics consent change event through window
	window.addEventListener("ucEvent", event => {
		if (
			event?.detail?.event == "consent_status" &&
			event?.detail?.type == "explicit"
		) {
			const allPurposesConsent = Object.entries(event.detail)
				.filter(([service]) => !["event", "type", "action"].includes(service))
				.every(([, consent]) => consent);

			resolve({
				uiShown: event?.detail?.action != "onInitialPageLoad",
				allPurposesConsent,
				triggerPrivacySettings: () => window.UC_UI.showSecondLayer(),
			});
		}
	});
});

export const hasAllPurposesConsent = new Promise((resolve, reject) => {
	hasConsentChecked.then(({ allPurposesConsent }) => {
		if (allPurposesConsent) {
			resolve();
		} else {
			reject();
		}
	});
});

export const hasUIShown = new Promise((resolve, reject) => {
	hasConsentChecked.then(({ uiShown }) => {
		if (uiShown) {
			resolve();
		} else {
			reject();
		}
	});
});
